<template>
  <div class="layout">
    <div class="layout_chidT">用户转化数据</div>
    <chart-block ref="chart"></chart-block>

    <div class="layout_chidT" style="margin-top: 10px;">实时访问数据</div>
    <div style="margin-left: -10px;">
      <chart-block ref="chart1"></chart-block>
    </div>
  </div>
</template>

<script>
const colorList = ['#9E87FF', '#05A64C', '#fe9a8b', '#F56948', '#9E87FF']
export default {
  name: 'Target',
  props: {
    userConversion: {
      type: Array,
      default: [],
    },
    userPvData: {
      type: Object,
      default: {},
    },
  },
  watch: {
    userConversion: {
      handler(newValue, oldValue) {
        this.$set(this.option.series[0], 'data', newValue)
        this.$refs.chart.setOption(this.option)
      },
      deep: true,
    },
    userPvData: {
      handler(pvData, oldValue) {
        this.$set(this.option1.series[0], 'data', this.handleData(pvData.sessionCnts))
        this.$set(this.option1.series[1], 'data', this.handleData(pvData.visitUvNews))
        this.$set(this.option1.series[2], 'data', this.handleData(pvData.toReals))
        this.$refs.chart1.setOption(this.option1)
      },
      deep: true,
    },
  },
  data() {
    return {
      option: {
        tooltip: {
          trigger: 'axis',
          extraCssText: 'z-index:1',
        },
        grid: {
          top: '0%',
          left: '2%',
          right: '10%',
          bottom: '0%',
          containLabel: true,
        },
        xAxis: [
          {
            splitLine: {
              show: false,
            },
            type: 'value',
            show: false,
          },
        ],
        yAxis: [
          {
            splitLine: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            type: 'category',
            axisTick: {
              show: false,
            },
            data: ['实名制注册总数', '二次授权总数', '一次授权总数'],
          },
        ],
        series: [
          {
            name: '总数',
            type: 'bar',
            barWidth: 12,
            label: {
              show: true,
              position: 'right',
              color: '#05A64C',
              fontSize: 14,
            },
            itemStyle: {
              borderRadius: [0, 5, 5, 0],
              color: '#05A64C',
            },
            data: [],
          },
        ],
      },
      option1: {
        tooltip: {
          trigger: 'axis',
          extraCssText: 'z-index:1',
          // formatter: (params) => {
          //   console.log(params)
          // },
        },
        grid: {
          top: '4%',
          left: '0%',
          right: '8%',
          bottom: '0%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
            axisLine: {
              lineStyle: {
                color: '#DCE2E8',
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 3,
              color: '#556677',
              fontSize: 12,
              margin: 15,
            },
            axisPointer: {
              label: {
                padding: [0, 0, 10, 0],
                margin: 15,
                fontSize: 12,
                backgroundColor: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: '#fff',
                    },
                    {
                      offset: 0.86,
                      color: '#fff',
                    },
                    {
                      offset: 0.86,
                      color: '#33c0cd',
                    },
                    {
                      offset: 1,
                      color: '#33c0cd',
                    },
                  ],
                  global: false,
                },
              },
            },
            boundaryGap: false,
          },
        ],
        yAxis: [
          {
            type: 'value',
            show: false,
          },
        ],
        series: [
          {
            name: '今日用户访问人数',
            type: 'line',
            data: [],
            symbolSize: 1,
            symbol: 'circle',
            smooth: true,
            yAxisIndex: 0,
            showSymbol: false,
            tooltip: {},
            lineStyle: {
              width: 3,
              shadowColor: 'rgba(115,221,255, 0.3)',
              shadowBlur: 10,
              shadowOffsetY: 20,
            },
            itemStyle: {
              color: colorList[1],
              borderColor: colorList[1],
            },
          },
          {
            name: '今日新用户访问人数',
            type: 'line',
            data: [],
            symbolSize: 1,
            symbol: 'circle',
            smooth: true,
            yAxisIndex: 0,
            showSymbol: false,
            tooltip: {},
            lineStyle: {
              width: 3,
              shadowColor: 'rgba(115,221,255, 0.3)',
              shadowBlur: 10,
              shadowOffsetY: 20,
            },
            itemStyle: {
              color: colorList[2],
              borderColor: colorList[2],
            },
          },
          {
            name: '今日完成实名制用户人数',
            type: 'line',
            data: [],
            symbolSize: 1,
            symbol: 'circle',
            smooth: true,
            yAxisIndex: 0,
            showSymbol: false,
            tooltip: {},
            lineStyle: {
              width: 3,
              shadowColor: 'rgba(115,221,255, 0.3)',
              shadowBlur: 10,
              shadowOffsetY: 20,
            },
            itemStyle: {
              color: colorList[3],
              borderColor: colorList[3],
            },
          },
        ],
      },
    }
  },
  mounted() {
    this.$refs.chart.setOption(this.option)
    this.$refs.chart1.setOption(this.option1)
  },
  methods: {
    handleData(arr) {
      let valueData = arr.map((v) => {
        return v.data == '' ? (v.data = 0) : v.data
      })
      return valueData
    },
  },
}
</script>

<style lang="less" scoped>
.layout {
  padding: 10px 20px;
  &_chidT {
    position: relative;
    margin-bottom: 10px;
    padding-left: 10px;
    text-align: left;
    font-size: 14px;
    font-weight: bold;
    color: #333;
    margin-top: 10px;
  }
  &_chidT::after {
    content: '';
    position: absolute;
    width: 4px;
    height: 18px;
    background-color: #05a64c;
    top: 0;
    left: 0px;
  }
}
</style>
